import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ReflectionFacade } from '../facades/reflection.facade';

export function reflectionCleanup<T>(): CanDeactivateFn<T> {
    return () => {
        const reflectionFacade = inject(ReflectionFacade);
        reflectionFacade.clear();

        return true;
    };
}
